import { lazy, type ComponentType, type ReactElement } from "react";

/** A route element for a screen loaded on first visit. Call at module scope only. */
export function page(load: () => Promise<{ default: ComponentType }>): ReactElement {
  const Screen = lazy(load);
  return <Screen />;
}
